import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PlannedRouteStateContext = createContext(null);

export const PlannedRouteStateProvider = ({ children }) => {
  const [plannedSearchState, setPlannedSearchState] = useState({
    formData: {
      vehicleIds: [],
      fromDate: "",
      toDate: "",
    },
    searchTerm: "",
    vehicleTrackingData: [],
    rowCount: 0,
  });

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // All screens that should keep the Planned Route list
    const inPlannedRouteModule =
      path.startsWith("/RoutePlanning/planned-route") ||
      path.startsWith("/RoutePlanning/planned-view") ||
    //   path.startsWith("/RoutePlanning/exptected-route") ||
      path.startsWith("/RoutePlanning/travel-view") ||
      path.startsWith("/RoutePlanning/trip-trakingView");

    // Clear only when leaving these screens
    if (!inPlannedRouteModule) {
      setPlannedSearchState({
        formData: {
          vehicleIds: [],
          fromDate: "",
          toDate: "",
        },
        searchTerm: "",
        vehicleTrackingData: [],
        rowCount: 0,
      });
    }
  }, [location.pathname]);

  return (
    <PlannedRouteStateContext.Provider
      value={{ plannedSearchState, setPlannedSearchState }}
    >
      {children}
    </PlannedRouteStateContext.Provider>
  );
};

export const usePlannedRouteState = () => {
  const ctx = useContext(PlannedRouteStateContext);
  if (!ctx) {
    throw new Error(
      "usePlannedRouteState must be used within PlannedRouteStateProvider"
    );
  }
  return ctx;
};
